import { brand, neutral } from "@/constants/colors";
import { Ionicons } from "@expo/vector-icons";
import React, { useEffect, useState } from "react";
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from "react-native";

interface CustomCheckboxProps {
  isChecked: boolean;
  onSelect?: () => void;
  onUnselect?: () => void;
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
}

export default function CustomCheckbox({
  isChecked,
  onSelect,
  onUnselect,
  style,
  disabled,
}: CustomCheckboxProps) {
  const [checked, setChecked] = useState(isChecked);

  const toggleCheckbox = () => {
    if (checked) {
      onUnselect?.();
      setChecked(false);
    } else {
      onSelect?.();
      setChecked(true);
    }
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <TouchableOpacity
      style={[styles.container, disabled && styles.disabled]}
      onPress={toggleCheckbox}
      disabled={disabled}
      activeOpacity={0.8}
    >
      <View style={[styles.checkbox, checked && styles.checked, style]}>
        {checked && (
          <Ionicons
            name="checkmark-outline"
            size={14}
            color={brand.primary.main}
            strokeWidth={3}
          />
        )}
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
  },
  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 6,
    borderWidth: 2,
    borderColor: neutral[300],
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  checked: {
    backgroundColor: brand.primary.faded,
    borderColor: brand.primary.main,
  },
  disabled: {
    opacity: 0.5,
  },
});
